import React, { useEffect, useState } from 'react';
import { studyAPI } from '../api/study';
import './PaymentModal.css';

function PaymentModal({ open, type, poemId, poemTitle, onClose, onSuccess, returnPath }) {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('MONTHLY');
  const [order, setOrder] = useState(null);
  const [polling, setPolling] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setOrder(null);
      setError('');
      setPolling(false);
      return;
    }
    if (type === 'TEXTBOOK_PLAN') {
      studyAPI.getTextbookPlans().then(setPlans).catch(() => setPlans([]));
    }
  }, [open, type]);

  useEffect(() => {
    if (!order || order.status === 'SUCCESS') return undefined;
    setPolling(true);
    const timer = setInterval(async () => {
      try {
        const status = await studyAPI.getPaymentOrder(order.orderNo);
        if (status.status === 'SUCCESS') {
          clearInterval(timer);
          setPolling(false);
          onSuccess(status);
        }
      } catch (e) {
        console.error('轮询订单失败', e);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [order, onSuccess]);

  const startOrder = async () => {
    setLoading(true);
    setError('');
    try {
      const body = {
        returnPath,
        orderType: type
      };
      if (type === 'TEXTBOOK_PLAN') {
        body.planCode = selectedPlan;
      } else if (type === 'POEM_UNLOCK') {
        body.poemId = poemId;
      }
      const result = await studyAPI.createPaymentOrder(body);
      setOrder(result);
    } catch (e) {
      setError(e?.response?.data?.message || '创建订单失败');
    } finally {
      setLoading(false);
    }
  };

  const confirmMockPay = async () => {
    if (!order?.orderNo) return;
    setLoading(true);
    try {
      await studyAPI.mockConfirmPayment(order.orderNo);
      const status = await studyAPI.getPaymentOrder(order.orderNo);
      onSuccess(status);
    } catch (e) {
      setError(e?.response?.data?.message || '模拟支付失败');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  const title = type === 'TEXTBOOK_PLAN'
    ? '开通教材学习套餐'
    : `解锁《${poemTitle || '古诗'}》`;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" onClick={e => e.stopPropagation()}>
        <h3>{title}</h3>
        {!order && type === 'TEXTBOOK_PLAN' && (
          <div className="plan-list">
            {plans.map(plan => (
              <button
                key={plan.code}
                type="button"
                className={`plan-item ${selectedPlan === plan.code ? 'active' : ''}`}
                onClick={() => setSelectedPlan(plan.code)}
              >
                <span className="plan-name">{plan.name}</span>
                <span className="plan-price">¥{(plan.priceCents / 100).toFixed(0)}</span>
                <span className="plan-monthly">约 ¥{(plan.monthlyDisplayCents / 100).toFixed(0)}/月</span>
              </button>
            ))}
          </div>
        )}
        {!order && type === 'POEM_UNLOCK' && (
          <p className="payment-hint">教材外古诗需单独解锁，解锁后可永久学习。</p>
        )}
        {!order && (
          <button className="payment-primary-btn" disabled={loading} onClick={startOrder}>
            {loading ? '处理中...' : type === 'POEM_UNLOCK' ? '支付 ¥5 解锁' : '去支付'}
          </button>
        )}
        {order && (
          <div className="payment-order-box">
            <p>订单金额：¥{(order.amountCents / 100).toFixed(2)}</p>
            {order.mockEnabled ? (
              <div className="mock-pay-box">
                <p>开发模式：点击下方按钮模拟扫码支付成功</p>
                <button className="payment-primary-btn" disabled={loading || polling} onClick={confirmMockPay}>
                  模拟支付成功
                </button>
              </div>
            ) : (
              <div className="qr-hint">
                <p>请使用微信扫一扫完成支付</p>
                <p className="code-url">{order.codeUrl}</p>
                {polling && <p className="polling-hint">等待支付结果...</p>}
              </div>
            )}
          </div>
        )}
        {error && <p className="payment-error">{error}</p>}
        <button type="button" className="payment-cancel-btn" onClick={onClose}>关闭</button>
      </div>
    </div>
  );
}

export default PaymentModal;
